enum WorkflowKind {
  Unknown = 0,
  Phone = 1,
  Email = 2,
  Address = 3,
  Name = 4,
  Photo = 5,
  BankAccount = 6,
  TaxExemption = 7,
  Leave = 8,
  Custom = 65535,
  Total = 999
}

export const ProfileChangeKinds = [
  WorkflowKind.Phone,
  WorkflowKind.Email,
  WorkflowKind.Address,
  WorkflowKind.Name,
  WorkflowKind.Photo,
  WorkflowKind.BankAccount,
  WorkflowKind.TaxExemption
];

export const AbsenceKinds = [WorkflowKind.Leave];

/**
 * Checks if a WorkflowKind is for profile changes.
 */
export const isProfileChangeKind = (kind: WorkflowKind): boolean =>
  ProfileChangeKinds.includes(kind);

/**
 * Checks if a WorkflowKind is for absences.
 */
export const isAbsenceKind = (kind: WorkflowKind): boolean =>
  AbsenceKinds.includes(kind);

/**
 * Groups WorkflowKind by categories.
 */
export const categorizeWorkflowKind = (kind: WorkflowKind): "ProfileChange" | "Absence" | "Other" => {
  if (isProfileChangeKind(kind)) return "ProfileChange";
  if (isAbsenceKind(kind)) return "Absence";
  return "Other";
};

export default WorkflowKind;
